<template>
  <div id="member-serve">
    <div class="qrcode">
      <img src="../../assets/images/qrcode.jpg" alt="" />
      <p>{{ this.$t("lang.openMember.scanCode") }}</p>
    </div>
    <div class="vip">
      <div class="vip-title">{{ this.$t("lang.openMember.limitedTime") }}</div>
      <div class="vip-list">
        <div class="vip-list-item" id="a">
          <p class="list-item-p" style="margin-top: 50px;">
            {{ this.$t("lang.openMember.healthInsurance") }}
          </p>
          <p class="list-item-p">
            {{ this.$t("lang.openMember.accompanyDuring") }}
          </p>
          <p :class="language">
            {{ this.$t("lang.openMember.leftDetail") }}
          </p>
        </div>
        <div class="vip-list-item">
          <p class="list-item-p" style="margin-top: 50px;">
            {{ this.$t("lang.openMember.psychologicalCounseling") }}
          </p>
          <p class="list-item-p">
            {{ this.$t("lang.openMember.cancerScreening") }}
          </p>
          <p :class="language">
            {{ this.$t("lang.openMember.rightDetail") }}
          </p>
        </div>
      </div>
    </div>
    <div class="member-serve-title">
      <p class="title-line"></p>
      <p class="title-content">{{ this.$t("lang.openMember.serviceList") }}</p>
      <p class="title-line"></p>
    </div>
    <div class="serve-list">
      <div
        v-for="item of cardList"
        :key="item.id"
        @mouseenter="handleMouseEnter(item.id)"
        @mouseleave="handleMouseLeave(item.id)"
        class="serve-list-item"
      >
        <!-- 正面 -->
        <transition name="el-fade-in-linear">
          <div v-show="item.flag" class="item-front">
            <p class="item-front-icon">
              <svg class="icon" aria-hidden="true">
                <use :xlink:href="item.icon"></use>
              </svg>
            </p>
            <p :class="languageFrontTitle">{{ item.title }}</p>
          </div>
        </transition>
        <!-- 背面 -->
        <transition name="el-zoom-in-top">
          <div v-show="!item.flag" class="item-behind">
            <p class="behind-title">{{ item.title }}</p>
            <p :class="languageBehindContent">{{ item.content }}</p>
            <p></p>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MemberServe",
  data() {
    return {
      flag: true,
      language: "",
      languageFrontTitle: "",
      languageBehindTitle: "",
      languageBehindContent: "",
      cardList: [
        {
          id: 1,
          title: this.$t("lang.openMember.makeAppointment"),
          icon: "#icon-yuyueguahao",
          flag: true,
          content: this.$t("lang.openMember.makeAppointmentDetail")
        },
        {
          id: 2,
          title: this.$t("lang.openMember.recommendingExperts"),
          icon: "#icon-tijianbaogao",
          flag: true,
          content: this.$t("lang.openMember.recommendingExpertsDetail")
        },
        {
          id: 3,
          title: this.$t("lang.openMember.consultOnline"),
          icon: "#icon-menzhenfuwukaobei",
          flag: true,
          content: this.$t("lang.openMember.consultOnlineDetail")
        },
        {
          id: 4,
          title: this.$t("lang.openMember.consultPhone"),
          icon: "#icon-bianminmenzhen",
          flag: true,
          content: this.$t("lang.openMember.consultPhoneDetail")
        },
        {
          id: 5,
          title: this.$t("lang.openMember.weightManagement"),
          icon: "#icon-wentifankui",
          flag: true,
          content: this.$t("lang.openMember.weightManagementDetail")
        },
        {
          id: 6,
          title: this.$t("lang.openMember.nutrientConsultation"),
          icon: "#icon-neifenmike",
          flag: true,
          content: this.$t("lang.openMember.nutrientConsultationDetail")
        }
      ]
    };
  },
  mounted() {
    this.setStyle();
  },
  beforeUpdate() {
    this.setStyle();
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    handleMouseEnter(id) {
      for (let i = 0; i < this.cardList.length; i++) {
        if (id === this.cardList[i].id) {
          this.cardList[i].flag = !this.cardList[i].flag;
        }
      }
    },
    handleMouseLeave(id) {
      for (let i = 0; i < this.cardList.length; i++) {
        if (id === this.cardList[i].id) {
          this.cardList[i].flag = !this.cardList[i].flag;
        }
      }
    },
    setStyle() {
      if (this.$i18n.locale === "en-US") {
        this.language = "list-item-details-us";
        this.languageBehindContent = "behind-content-us";
        this.languageFrontTitle = "item-front-title-us";
      } else if (this.$i18n.locale === "zh-CN") {
        this.language = "list-item-details";
        this.languageBehindContent = "behind-content";
        this.languageFrontTitle = "item-front-title";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/global";
#member-serve {
  overflow: hidden;
  .qrcode {
    height: 110px;
    width: 110px;
    margin: 30px auto;
    font-size: 12px;
    text-align: center;
    color: #2a2a2a;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .member-serve-title {
    margin-top: 82px;
    margin-bottom: 93px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    .title-content {
      margin: 0 18px;
      font-size: 24px;
      color: #218ae8;
      font-weight: 500;
    }
    .title-line {
      width: 362px;
      height: 2px;
      background: #cfcfcf;
    }
  }
  .serve-list {
    margin: 0 auto;
    width: 900px;
    display: flex;
    flex-wrap: wrap;
    .serve-list-item {
      height: 190px;
      width: 188px;
      background: #ffffff;
      margin-left: 85px;
      margin-bottom: 50px;
      border-radius: 8px;
      box-shadow: 0 10px 10px #eaf4fa;
      position: relative;
      /* 前面 */
      .item-front {
        position: absolute;
        height: 100%;
        width: 100%;
        text-align: center;
        .item-front-icon {
          margin-top: 42px;
        }
        .item-front-title {
          margin-top: 30px;
          font-size: 24px;
          font-weight: $weight400;
          color: #5b8df3;
        }
        .item-front-title-us {
          margin-top: 30px;
          font-size: 18px;
          font-weight: $weight400;
          color: #5b8df3;
        }
      }
      /* 后面 */
      .item-behind {
        position: absolute;
        height: 100%;
        width: 100%;
        background: linear-gradient(#2596f6, #7cd0fb);
        border-radius: 8px;
        text-align: center;
        overflow: hidden;
        .behind-title {
          margin-top: 28px;
          color: #ffffff;
          font-size: 20px;
          font-weight: $weight500;
        }
        .behind-content {
          overflow: hidden;
          text-align: left;
          color: #ffffff;
          font-size: 14px;
          line-height: 25px;
          margin: 24px;
        }
        .behind-content-us {
          word-break: break-all;
          overflow: hidden;
          text-align: left;
          color: #ffffff;
          font-size: 12px;
          line-height: 16px;
          margin: 12px;
        }
      }
    }
  }
  .vip {
    margin: 50px auto;
    width: 900px;
    text-align: center;
    overflow: hidden;
    .vip-title {
      color: #0090f3;
      font-size: 24px;
    }
    .vip-list {
      margin-top: 26px;
      display: flex;
      justify-content: center;
      .vip-list-item {
        height: 530px;
        width: 300px;
        margin-top: 20px;
        margin-bottom: 30px;
        overflow: hidden;
        background: #ffffff;
        border-radius: 8px;
        box-shadow: -2px 7px 21px 3px rgba(130, 195, 255, 0.13);
        .list-item-p {
          height: 40px;
          color: #5b8df3;
          font-size: 20px;
          font-weight: $weight400;
          line-height: 20px;
        }
        .list-item-details {
          word-break: break-all;
          margin-top: 10px;
          padding: 0 50px;
          line-height: 24px;
          text-align: left;
          color: #b2b2b2;
          font-weight: $weight400;
        }
        .list-item-details-us {
          word-break: break-all;
          margin-top: 10px;
          padding: 0 30px;
          font-size: 14px;
          line-height: 16px;
          text-align: left;
          color: #b2b2b2;
          font-weight: $weight400;
        }
      }
    }
  }
}
.icon {
  width: 54px;
  height: 57px;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
#a {
  margin-right: 47px;
}
</style>
